export var ModalActionType;
(function (ModalActionType) {
    ModalActionType["spawnModal"] = "SPAWN_MODAL";
    ModalActionType["despawnModal"] = "DESPAWN_MODAL";
    ModalActionType["despawnAllModals"] = "DESPAWN_ALL_MODALS";
})(ModalActionType || (ModalActionType = {}));
export function modalReducer(state, action) {
    switch (action.type) {
        case ModalActionType.spawnModal:
            return {
                ...state,
                stack: [
                    ...state.stack,
                    {
                        content: action.content,
                        fullscreen: !!action.fullscreen,
                    },
                ],
            };
        case ModalActionType.despawnModal:
            const stackCopy = [...state.stack];
            stackCopy.pop();
            return {
                ...state,
                stack: stackCopy,
            };
        case ModalActionType.despawnAllModals:
            return {
                ...state,
                stack: [],
            };
        default:
            return state;
    }
}
//# sourceMappingURL=modalReducer.js.map